import { CommonModule, NgFor } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { userRoleEnum } from '../../constants/user-roles.enum';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../core/services/authService/auth-service.service';
import { Subscription } from 'rxjs';
import { UserAssingPayload } from '@edtech-ui/core/models/interfaces/userRole';
import { AuthRedirectService } from '@edtech-ui/core/services/auth-redirect/auth-redirect.service';

@Component({
	selector: 'app-role',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './role.component.html',
	styleUrl: './role.component.scss'
})
export class RoleComponent implements OnInit, OnDestroy {

	selectedRole: userRoleEnum | '' = '';
	selectedRoleId: number | null = null;
	userId!: number;
	subscription = new Subscription();
	isTenantOnBoard: boolean = false;
	isTenantOnBoardGoogle: boolean = false;
	userRoleEnum = userRoleEnum;

	users = [
		{ role: userRoleEnum.TEACHER, name: 'Educator/Teacher', para: 'Empower your classroom with smart tools. Create and manage courses, generate quizzes and assignments automatically, share study materials and monitor your student’s progress – all in one place.', image: 'assets/images/teacher.png', role_id: 1 },
		{ role: userRoleEnum.STUDENT, name: 'Learner/Student', para: 'Enhance your learning experience. Join classes, access study materials, complete assignments and quizzes, and track your performance as you progress through your courses.', image: 'assets/images/student.png', role_id: 2 },
		{ role: userRoleEnum.MENTOR, name: 'Expert Mentor', para: 'Share your expert knowledge and guide students. Manage session requests, host upcoming sessions, and track your session history all in one place with our mentor dashboard.', image: 'assets/images/mentor.png', role_id: 5 }
	]

	constructor(private router: Router,
		private _authService: AuthServiceService,
		private _toastr: ToastrService,
		private _authRedirectService: AuthRedirectService
	) { }

	ngOnInit(): void {
		this.isTenantOnBoard = JSON.parse(localStorage.getItem('is_tenant_onboard') || 'false'),
			this.isTenantOnBoardGoogle = JSON.parse(localStorage.getItem('is_tenant_onboard') || 'false');

		const roleModeGoogle = localStorage.getItem('role_mode_google');
		const roleModeNormal = localStorage.getItem('role_mode');

		if (roleModeGoogle) {
			this.handleGoogleRole(roleModeGoogle);
		} else {
			this.handleNormalRole(roleModeNormal || 'both');
		}
		this._authRedirectService.redirectIfLoggedIn();
	}

	selectRole(role: userRoleEnum, roleId: number) {
		this.selectedRole = role;
		this.selectedRoleId = roleId;
	}

	postAssignRole() {
		if (!this.selectedRoleId || !this.selectedRole) {
			this._toastr.error("Please select a role.");
			return;
		}

		const isGoogleFlow = !!localStorage.getItem('role_mode_google');

		const onboardTenantStatus = isGoogleFlow
			? (this.isTenantOnBoard)
			: (this.isTenantOnBoardGoogle);


		const payload: UserAssingPayload = {
			user_id: localStorage.getItem('user_id') ?? this._authService.currentUserId.getValue(),
			role_id: this.selectedRoleId,
			is_tenant_onboard: onboardTenantStatus,
		};

		this.subscription.add(
			this._authService.postUserRole(payload).subscribe({
				next: (response) => {
					if (response.Success) {
						localStorage.setItem('token', response.Data.token);
						localStorage.setItem('user_id', response.Data.user_id);
						localStorage.setItem('role_id', response.Data.role_id.toString());
						localStorage.setItem('refresh_token', response.Data.refresh_token);

						this._authService.currentUserId.next(response.Data.user_id);
						localStorage.removeItem('role_mode');
						localStorage.removeItem('role_mode_google');
						localStorage.removeItem('is_tenant_onboard');

						if (this.selectedRole === userRoleEnum.TEACHER) {
							this.router.navigate(['/teacher-dashboard']);
						} else if (this.selectedRole === userRoleEnum.MENTOR) {
							this.router.navigate(['/mentor-panel']);
						} else {
							this.router.navigate(['/student-dashboard']);
						}
					} else {
						this._toastr.error(response.Message || "Role assignment failed.");
					}
				},
				error: () => {
					this._toastr.error("Something went wrong while assigning role.");
				}
			})
		);
	}

	handleNormalRole(roleMode: string) {
		switch (roleMode) {
			case 'teacher':
				this.users = this.users.filter(u => u.role === userRoleEnum.TEACHER);
				break;
			case 'student':
				this.users = this.users.filter(u => u.role === userRoleEnum.STUDENT);
				break;
			case 'both':
			default:
				break;
		}
	}

	handleGoogleRole(roleModeGoogle: string) {
		switch (roleModeGoogle) {
			case 'teacher':
				this.users = this.users.filter(u => u.role === userRoleEnum.TEACHER);
				break;
			case 'student':
				this.users = this.users.filter(u => u.role === userRoleEnum.STUDENT);
				break;
			case 'both':
			default:
				break;
		}
	}


	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}